import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-inline',
  templateUrl: './alert-inline.component.html',
  styleUrls: ['./alert-inline.component.scss']
})
export class AlertInlineComponent implements OnInit {

  @Input() message = '';

  constructor() { }

  ngOnInit(): void {
  }

}
